import { useMsal } from '@azure/msal-react'
import { useEffect } from 'react'

import { appInsights } from '@/analytics.ts'
import InfoToast from '@/components/infoToast'
import { currentEnv } from '@/env/vars.ts'
import { getChatExamples, getSnippetSources, getUserMembership } from '@/store/gigiChat/ChatAtom'
import { getTopics } from '@/store/helpCenter'
import { getNews } from '@/store/news'
import { getApprovals, getCompliances } from '@/store/tasksApprovals'
import { getWidgets } from '@/store/tasksApprovals/widgets'

import DisplayQuota from './component/DisplayQuota'

const AppRoot = () => {
    const { accounts } = useMsal()
    const user = accounts[0]

    useEffect(() => {
        const onLoad = async () => {
            await Promise.allSettled([
                getCompliances(),
                getApprovals(),
                getWidgets(),
                getTopics(),
                getSnippetSources().then(() => getUserMembership()),
                getChatExamples(),
                (() => (currentEnv.features.isEnabled('news') ? getNews(true) : Promise.resolve()))(),
            ]).catch((error) => {
                console.error('Unexpected error:', error)
            })
        }
        void onLoad()
    }, [])

    useEffect(() => {
        if (user) {
            appInsights.setAuthenticatedUserContext(user.username)
        }
    }, [user])

    return (
        <>
            <InfoToast />
            <DisplayQuota />
        </>
    )
}

export default AppRoot
